import PropTypes from 'prop-types';
import { FISCAL_PERIOD_TYPE } from 'utils/fiscalPeriods';

export const fiscalPeriodPropTypes = {
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired,
    details: PropTypes.shape({
        year: PropTypes.number,
        grouping: PropTypes.string,
        type: PropTypes.oneOf([FISCAL_PERIOD_TYPE.CUSTOM, FISCAL_PERIOD_TYPE.PREDEFINED]),
        name: PropTypes.string, // name of period if predefined
        id: PropTypes.number, // ID of period if predefined
    }),
    pointInTime: PropTypes.string, // optional custom point in time the data is viewed from
};
